export const USER_LEVEL = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  STANDARD: 'standard',
};

export const USER_LEVEL_NAMES = {
  [USER_LEVEL.SUPER_ADMIN]: 'Super Administrator',
  [USER_LEVEL.ADMIN]: 'Administrator',
  [USER_LEVEL.STANDARD]: 'Standard',
};

export const PAGE_SIZE = 1;



export const COUNTRY_PHONE_PREFIXES = {
  'ES': '+34',    // España
  'AD': '+376',   // Andorra
  'AE': '+971',   // Emiratos Árabes Unidos
  'AF': '+93',    // Afganistán
  'AG': '+1-268', // Antigua y Barbuda
  'AI': '+1-264', // Anguila
  'AL': '+355',   // Albania
  'AM': '+374',   // Armenia
  'AN': '+599',   // Antillas Holandesas
  'AO': '+244',   // Angola
  'AQ': 'N/A',    // Antártida
  'AR': '+54',    // Argentina
  'AS': '+1-684', // Samoa Americana
  'AT': '+43',    // Austria
  'AU': '+61',    // Australia
  'AW': '+297',   // Aruba
  'AZ': '+994',   // Azerbaiyán
  'BA': '+387',   // Bosnia Herzegovina
  'BB': '+1-246', // Barbados
  'BD': '+880',   // Bangladesh
  'BE': '+32',    // Bélgica
  'BF': '+226',   // Burkina Faso
  'BG': '+359',   // Bulgaria
  'BH': '+973',   // Bahrein
  'BI': '+257',   // Burundi
  'BJ': '+229',   // Benín
  'BM': '+1-441', // Bermudas
  'BN': '+673',   // Brunei
  'BO': '+591',   // Bolivia
  'BR': '+55',    // Brasil
  'BS': '+1-242', // Bahamas
  'BT': '+975',   // Bután
  'BW': '+267',   // Botswana
  'BY': '+375',   // Bielorrusia
  'BZ': '+501',   // Belice
  'CA': '+1',     // Canadá
  'CD': '+243',   // Rep. Democrática del Congo
  'CF': '+236',   // República Centroafricana
  'CG': '+242',   // Congo
  'CH': '+41',    // Suiza
  'CI': '+225',   // Costa de Marfil
  'CK': '+682',   // Islas Cook
  'CL': '+56',    // Chile
  'CM': '+237',   // Camerún
  'CN': '+86',    // China
  'CO': '+57',    // Colombia
  'CR': '+506',   // Costa Rica
  'CU': '+53',    // Cuba
  'CV': '+238',   // Cabo Verde
  'CY': '+357',   // Chipre
  'CZ': '+420',   // República Checa
  'DE': '+49',    // Alemania
  'DJ': '+253',   // Yibuti
  'DK': '+45',    // Dinamarca
  'DM': '+1-767', // Dominica
  'DO': '+1-809', // República Dominicana
  'DZ': '+213',   // Argelia
  'EC': '+593',   // Ecuador
  'EE': '+372',   // Estonia
  'EG': '+20',    // Egipto
  'ER': '+291',   // Eritrea
  'ET': '+251',   // Etiopía
  'FI': '+358',   // Finlandia
  'FJ': '+679',   // Fiyi
  'FK': '+500',   // Islas Malvinas
  'FM': '+691',   // Micronesia
  'FO': '+298',   // Islas Feroe
  'FR': '+33',    // Francia
  'GA': '+241',   // Gabón
  'GB': '+44',    // Reino Unido
  'GD': '+1-473', // Granada
  'GE': '+995',   // Georgia
  'GF': '+594',   // Guayana Francesa
  'GH': '+233',   // Ghana
  'GI': '+350',   // Gibraltar
  'GL': '+299',   // Groenlandia
  'GM': '+220',   // Gambia
  'GN': '+224',   // Guinea
  'GP': '+590',   // Guadalupe
  'GQ': '+240',   // Guinea Ecuatorial
  'GR': '+30',    // Grecia
  'GT': '+502',   // Guatemala
  'GW': '+245',   // Guinea-Bissau
  'GY': '+592',   // Guyana
  'HK': '+852',   // Hong Kong
  'HN': '+504',   // Honduras
  'HR': '+385',   // Croacia
  'HU': '+36',    // Hungría
  'ID': '+62',    // Indonesia
  'IE': '+353',   // Irlanda
  'IL': '+972',   // Israel
  'IM': '+44-1624', // Isla de Man
  'IN': '+91',    // India
  'IO': '+246',   // Territorio Británico del Océano Índico
  'IQ': '+964',   // Iraq
  'IR': '+98',    // Irán
  'IS': '+354',   // Islandia
  'IT': '+39',    // Italia
  'JE': '+44-1534', // Jersey
  'JM': '+1-876', // Jamaica
  'JO': '+962',   // Jordania
  'JP': '+81',    // Japón
  'KE': '+254',   // Kenia
  'KG': '+996',   // Kirguistán
  'KH': '+855',   // Camboya
  'KI': '+686',   // Kiribati
  'KM': '+269',   // Comoras
  'KN': '+1-869', // San Cristóbal y Nieves
  'KP': '+850',   // Corea del Norte
  'KR': '+82',    // Corea del Sur
  'KW': '+965',   // Kuwait
  'KY': '+1-345', // Islas Caimán
  'KZ': '+7',     // Kazajistán
  'LA': '+856',   // Laos
  'LB': '+961',   // Líbano
  'LC': '+1-758', // Santa Lucía
  'LI': '+423',   // Liechtenstein
  'LK': '+94',    // Sri Lanka
  'LR': '+231',   // Liberia
  'LS': '+266',   // Lesoto
  'LT': '+370',   // Lituania
  'LU': '+352',   // Luxemburgo
  'LV': '+371',   // Letonia
  'LY': '+218',   // Libia
  'MA': '+212',   // Marruecos
  'MC': '+377',   // Mónaco
  'MD': '+373',   // Moldavia
  'MG': '+261',   // Madagascar
  'MH': '+692',   // Islas Marshall
  'MK': '+389',   // Macedonia
  'ML': '+223',   // Malí
  'MM': '+95',    // Myanmar
  'MN': '+976',   // Mongolia
  'MO': '+853',   // Macao
  'MP': '+1-670', // Islas Marianas del Norte
  'MQ': '+596',   // Martinica
  'MR': '+222',   // Mauritania
  'MS': '+1-664', // Montserrat
  'MT': '+356',   // Malta
  'MU': '+230',   // Mauricio
  'MV': '+960',   // Maldivas
  'MW': '+265',   // Malawi
  'MX': '+52',    // México
  'MY': '+60',    // Malasia
  'MZ': '+258',   // Mozambique
  'NA': '+264',   // Namibia
  'NC': '+687',   // Nueva Caledonia
  'NE': '+227',   // Níger
  'NG': '+234',   // Nigeria
  'NI': '+505',   // Nicaragua
  'NL': '+31',    // Países Bajos
  'NO': '+47',    // Noruega
  'NP': '+977',   // Nepal
  'NR': '+674',   // Nauru
  'NZ': '+64',    // Nueva Zelanda
  'OM': '+968',   // Omán
  'PA': '+507',   // Panamá
  'PE': '+51',    // Perú
  'PF': '+689',   // Polinesia Francesa
  'PG': '+675',   // Papúa Nueva Guinea
  'PH': '+63',    // Filipinas
  'PK': '+92',    // Pakistán
  'PL': '+48',    // Polonia
  'PN': '+64',    // Islas Pitcairn
  'PR': '+1-787', // Puerto Rico
  'PS': '+970',   // Palestina
  'PT': '+351',   // Portugal
  'PW': '+680',   // Palau
  'PY': '+595',   // Paraguay
  'QA': '+974',   // Catar
  'RE': '+262',   // Reunión
  'RO': '+40',    // Rumanía
  'RS': '+381',   // Serbia
  'RU': '+7',     // Rusia
  'RW': '+250',   // Ruanda
  'SA': '+966',   // Arabia Saudí
  'SB': '+677',   // Islas Salomón
  'SC': '+248',   // Seychelles
  'SD': '+249',   // Sudán
  'SE': '+46',    // Suecia
  'SG': '+65',    // Singapur
  'SH': '+290',   // Santa Helena
  'SI': '+386',   // Eslovenia
  'SJ': '+47',    // Svalbard y Jan Mayen
  'SK': '+421',   // Eslovaquia
  'SL': '+232',   // Sierra Leona
  'SM': '+378',   // San Marino
  'SN': '+221',   // Senegal
  'SO': '+252',   // Somalia
  'SR': '+597',   // Surinam
  'ST': '+239',   // Santo Tomé y Príncipe
  'SV': '+503',   // El Salvador
  'SY': '+963',   // Siria
  'SZ': '+268',   // Suazilandia
  'TC': '+1-649', // Islas Turcas y Caicos
  'TD': '+235',   // Chad
  'TG': '+228',   // Togo
  'TH': '+66',    // Tailandia
  'TJ': '+992',   // Tayikistán
  'TM': '+993',   // Turkmenistán
  'TN': '+216',   // Túnez
  'TO': '+676',   // Tonga
  'TR': '+90',    // Turquía
  'TT': '+1-868', // Trinidad y Tobago
  'TV': '+688',   // Tuvalu
  'TW': '+886',   // Taiwán
  'TZ': '+255',   // Tanzania
  'UA': '+380',   // Ucrania
  'UG': '+256',   // Uganda
  'US': '+1',     // Estados Unidos
  'UY': '+598',   // Uruguay
  'UZ': '+998',   // Uzbekistán
  'VA': '+379',   // Ciudad del Vaticano
  'VC': '+1-784', // San Vicente y las Granadinas
  'VE': '+58',    // Venezuela
  'VG': '+1-284', // Islas Vírgenes Británicas
  'VI': '+1-340', // Islas Vírgenes Estadounidenses
  'VN': '+84',    // Vietnam
  'VU': '+678',   // Vanuatu
  'WF': '+681',   // Wallis y Futuna
  'YE': '+967',   // Yemen
  'YT': '+262',   // Mayotte
  'ZA': '+27',    // Sudáfrica
  'ZM': '+260',   // Zambia
  'ZW': '+263'    // Zimbabue
}
